import { Permissions } from '@or-sdk/permissions';

import config from '@/config';
import { useAuth } from '@/stores';

export default new Permissions({
  permissionsUrl: config.PERMISSIONS_API_URL,
  token: () => {
    return `USER ${useAuth().reactiveToken}`;
  },
});
